// Technical drawing: fetched near the viewport, inlined, then traced part by part once on screen.
class QoDrawing extends HTMLElement {
  connectedCallback() {
    this.loader = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      this.loader.disconnect();
      this.load();
    }, { rootMargin: '600px 0px' });
    this.loader.observe(this);
    // One drawing per spec tab: a hidden drawing loads and traces the first time its tab is shown.
    if (this.dataset.tab) {
      this.section = this.closest('.shopify-section');
      this.onTab = (event) => (this.hidden = Number(this.dataset.tab) !== event.detail.index + 1);
      this.section?.addEventListener('qo-tabs:change', this.onTab);
    }
  }

  disconnectedCallback() {
    this.loader?.disconnect();
    this.trigger?.disconnect();
    this.section?.removeEventListener('qo-tabs:change', this.onTab);
  }

  async load() {
    let markup;
    try {
      const response = await fetch(this.dataset.src);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      markup = await response.text();
    } catch (error) {
      console.error('qo-drawing: could not load', this.dataset.src, error);
      return;
    }
    const svg = new DOMParser().parseFromString(markup, 'image/svg+xml').querySelector('svg');
    if (!svg) return;
    this.replaceChildren(document.importNode(svg, true));
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) return;
    this.arm();
  }

  arm() {
    // data-order sets the trace sequence; document order stays free for paint stacking.
    this.querySelectorAll('[data-part]').forEach((part, index) => part.style.setProperty('--i', part.dataset.order ?? index));
    this.querySelectorAll('path').forEach((path) => path.setAttribute('pathLength', '1'));
    this.dataset.state = 'armed';
    this.trigger = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      this.trigger.disconnect();
      requestAnimationFrame(() => (this.dataset.state = 'drawn'));
    }, { threshold: 0.35 });
    this.trigger.observe(this);
  }
}

if (!customElements.get('qo-drawing')) customElements.define('qo-drawing', QoDrawing);
